// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.widget-listingsearch {
    max-width: 750px;
    margin: auto;
  }

.widget-listingsearch.style4 {
    max-width: 100%;
  }
  .widget-listingsearch.style4 .search_jobs {
    padding: 5px;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    -o-border-radius: 3px;
    background: #fff;
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .search_jobs {
      padding: 10px;
    }
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .search-submit {
      padding-left: 70px;
      padding-right: 70px;
    }
  }
  .widget-listingsearch.style4 .search-submit i {
    display: none;
  }

  
  .wpb_wrapper.head.blu:before {
    background-image: radial-gradient(farthest-corner at 0% 100%,  #004C6C 0%, #53b8e2  100%);
    background-image: -webkit-radial-gradient(farthest-corner at 0% 100%,  #004C6C 0%, #53b8e2  100%);  
  }
  .wpb_wrapper.head:before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: bottom;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    opacity: 0.7;
    filter: alpha(opacity = 70);
    width: 100%;
    height: 100%;
  background-repeat: repeat-x;
}

.wpb_wrapper_blue.head:before {
  background-image: none;
  opacity: 1;
  background-color: #1f80a8;
}

.wpb_wrapper_red.head:before {
  background-image: none;
  opacity: 1;
  background-color: #bf1155;
}

.wpb_wrapper_green.head:before {
  background-image: none;
  opacity: 1;
  background-color: #7a8e29;
}

.wpb_wrapper_aqua.head:before {
  background-image: none;
  opacity: 1;
  background-color: #05948d;
}

.wpb_wrapper_orange.head:before {
  background-image: none;
  opacity: 1;
  background-color: #d0810e;
}

.wpb_wrapper { color: #fff; position: relative; }
.wpb_wrapper .description { font-size: 1.8em;
}
.wpb_wrapper h2 { color: #fff;
    font-size: 45px;
    font-weight: 700;
    margin: 0;
    text-align: center;
 }


 .job_search_form .has-suggestion {
    position: relative;
    width: 360px;
    max-width: 100%;
  }
  .job_search_form .has-suggestion.active .navbar-collapse {
    opacity: 1;
    filter: alpha(opacity=100);
    visibility: visible;
  }
  .job_search_form .has-suggestion .navbar-collapse {
    opacity: 0;
    filter: alpha(opacity=0);
    visibility: hidden;
    transition: all 0.2s ease-in-out 0s;
    min-width: 360px;
    z-index: 99;
    padding: 0;
    position: absolute;
    top: 100%;
    margin-top: 0;
    left: -5px;
  }
  .rtl .job_search_form .has-suggestion .navbar-collapse {
    right: -5px;
    left: auto;
  }
  .job_search_form .filters_end {
    display: none;
  }
  .job_search_form .search_categories,
  .job_search_form .search_location {
    width: 220px;
    max-width: 100%;
  }
  .job_search_form .search-submit {
    font-size: 17px;
    font-weight: 300;
    padding: 9px 30px;
  }
  .job_search_form .search-submit i {
    line-height: 1;
    vertical-align: sub;
    margin-left: 10px;
  }
  .rtl .job_search_form .search-submit i {
    margin-right: 10px;
    margin-left: inherit;
  }
  .job_search_form .chosen-container-single,
  .job_search_form input {
    width: 100%;
    height: 50px;
    padding: 10px 20px;
    border: none;
    background: #fff;
    box-shadow: none !important;
    border-radius: 3px;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    -ms-border-radius: 3px;
    -o-border-radius: 3px;
  }
  .job_search_form .chosen-container-single.search_location,
  .job_search_form input.search_location {
    padding: 10px 30px 10px 20px;
  }
  .job_search_form input {
    color: #67676f;
  }
  .job_search_form input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #67676f;
  }
  .job_search_form input::-moz-placeholder {
    /* Firefox 19+ */
    color: #67676f;
  }
  .job_search_form input:-ms-input-placeholder {
    /* IE 10+ */
    color: #67676f;
  }
  .job_search_form input:-moz-placeholder {
    /* Firefox 18- */
    color: #67676f;
  }
  .job_search_form #search_keywords {
    padding: 10px 20px;
  }
  .job_search_form .chosen-container {
    font-size: 13px;
  }
  .job_search_form .chosen-single {
    padding: 2px;
    border: none !important;
    background: #fff !important;
    box-shadow: none !important;
  }
  .job_search_form .chosen-single > div {
    top: 2px !important;
  }
  .job_search_form .search_jobs > .inner-left {
    width: 100%;
  }
  .job_search_form .table-wrapper > div {
    position: relative;
  }
  .job_search_form .table-wrapper > div:last-child:before {
    display: none;
  }

  @media (min-width: 1200px) {
  .job_search_form .table-wrapper > div:before {
    content: '';
    width: 1px;
    height: 30px;
    background: #d7d7d7;
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 9;
  }
}
  .rtl .job_search_form .table-wrapper > div:before {
    left: 0;
    right: auto;
  }
  .job_search_form .search_location {
    position: relative;
  }
  .job_search_form .search_location .clear-location {
    background: transparent;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    position: absolute;
    right: 25px;
    text-align: center;
    top: 2px;
    width: 20px;
  }
  .rtl .job_search_form .search_location .clear-location {
    left: 25px;
    right: auto;
  }
  .job_search_form .search_location .clear-location i {
    display: block;
    font-size: 18px;
    line-height: 43px;
    color: #fb3640;
  }
  .job_search_form .search_location .find-me {
    background: transparent;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 2px;
    width: 20px;
  }
  .rtl .job_search_form .search_location .find-me {
    left: 10px;
    right: auto;
  }
  .job_search_form .search_location .find-me i {
    display: block;
  }
  .job_search_form .search_location .find-me.loading {
    background: transparent;
  }
  .job_search_form .search_location .find-me.loading > * {
    animation: rotate 700ms linear 0s normal none infinite running;
    -webkit-animation: rotate 700ms linear 0s normal none infinite running;
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .search_jobs {
      padding: 10px;
    }
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .search-submit {
      padding-left: 70px;
      padding-right: 70px;
    }
  }

  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {
      top: -10px;
      height: 70px;
    }
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .job_search_form .search_location,
    .widget-listingsearch.style4 .job_search_form .search_categories {
      padding: 0 10px;
    }
    .widget-listingsearch.style4 .job_search_form .search_location .find-me {
      right: 20px;
    }
    .rtl .widget-listingsearch.style4 .job_search_form .search_location .find-me {
      left: 20px;
      right: auto;
    }
    .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {
      left: -10px;
      width: 100%;
    }
}
.widget-listingsearch.style4 .chosen-container-single .chosen-single span {
  color: #67676f;
}
.widget-listingsearch.style4 .job_search_form .search_location .clear-location {
  right: 35px;
}
.rtl .widget-listingsearch.style4 .job_search_form .search_location .clear-location {
  left: 35px;
  right: auto;
}
.widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {
    width: 1px;
    height: 60px;
    top: -5px;
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {
      top: -10px;
      height: 70px;
    }
  }
  @media (min-width: 1200px) {
    .widget-listingsearch.style4 .job_search_form .search_location,
    .widget-listingsearch.style4 .job_search_form .search_categories {
      padding: 0 10px;
    }
    .widget-listingsearch.style4 .job_search_form .search_location .find-me {
      right: 20px;
    }
    .rtl .widget-listingsearch.style4 .job_search_form .search_location .find-me {
      left: 20px;
      right: auto;
    }
    .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {
      left: -10px;
      width: 100%;
    }
    .rtl .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {
      right: -10px;
      left: auto;
    }
  }
  .widget-listingsearch.style4 .chosen-container-single .chosen-single span {
    color: #67676f;
  }
  .widget-listingsearch.style4 .job_search_form .search_location .clear-location {
    right: 35px;
  }
  .rtl .widget-listingsearch.style4 .job_search_form .search_location .clear-location {
    left: 35px;
    right: auto;
  }


  .categories-inner {
    text-align: center;
  }
.listing-category-item {
    transition: all 0.2s ease-in-out 0s;
    display: inline-block;
    text-align: center;
    padding: 0 5px;
    margin-bottom: 10px;
}

.listing-category-item  .inner {
    padding: 8px 5px;
    background: rgba(255, 255, 255, 0.28);
}
.listing-category-item .category-icon {
    color: #fff;
    font-size: 35px;
    display: inline-block;
    line-height: 1;
}

.listing-category-item .inner {
    max-width: 30vw;
    min-width: 23vw;
}

.listing-category-item .category-info-title {
    font-size: 16px;
    color: #fff;
}
.widget-listing-categories.style5 .category-number {
    display: none;
}

.search_jobs select  {
    height: 100%;
    border-bottom-width: 0 !important;
}
.search_jobs .visible-table  {
    display: flex;
    justify-content: space-between;
}
.search_jobs .grow1  {
    flex-grow: 1;
}

.search_jobs .search-submit {
    background: #004C6C;
    border-color: #004C6C;
    color: #FFF; 
    display: flex;
    width: 100%;
    height: 100%;
}


@media (max-width: 1200px) {
    .search_jobs .visible-table  {
        flex-direction: column !important;
    }
    .search_jobs .visible-table  > * {
        width: 100%;
    }
    .search-filter-wrapper {
        margin-bottom: 5px;
        padding: 0;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
    }
}

.react-multi-carousel-list  img { max-width: 100%;}

select {
    padding: 10px 20px;
}

.card-home {
    padding: 20px;
    margin-top: 10rem;
}

.dashboard-container .card {
  margin-top: 0em;
}

.apus-footer {
  position: relative;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10rem 0 0;
}

.apus-footer .purple {
    background: #252c41;
    color: #858b9f;
  }
  .apus-footer .purple .wpb_heading,
  .apus-footer .purple .widget-title, .apus-footer .purple .widgettitle {
    color: #fff;
  }
  .apus-footer .purple a:not([classs]) {
    color: #858b9f;
  }
  .apus-footer .purple a:not([classs]):hover, .apus-footer .purple a:not([classs]):active, .apus-footer .purple a:not([classs]):focus {
    color: #fff;
  }
  .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a {
    border-color: #3c4358;
  }
  .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a:hover, .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a:focus {
    border-color: #fff;
  }
  .menu {
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .menu li {
    margin-bottom: 3px;
  }
  .menu li:last-child {
    margin: 0;
  }
  .widget_nav_menu .menu li a {
    padding: 5px 0;
    display: inline-block;
    text-decoration: none;
}    

.apus-footer .widgettitle {
    text-align: left;
    color: #28b8dc;
    font-size: 18px;
    font-weight: 400;
    margin: 0 0 10px;
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":";;AAEA;IACI,gBAAgB;IAChB,YAAY;EACd;;AAEF;IACI,eAAe;EACjB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;EACA;IACE,aAAa;EACf;;;EAGA;IACE,yFAAyF;IACzF,iGAAiG;EACnG;EACA;IACE,yDAA+C;IAC/C,sBAAsB;IACtB,2BAA2B;IAC3B,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,2BAA2B;IAC3B,WAAW;IACX,YAAY;EACd,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,yBAAyB;AAC3B;;AAEA,eAAe,WAAW,EAAE,kBAAkB,EAAE;AAChD,4BAA4B,gBAAgB;AAC5C;AACA,kBAAkB,WAAW;IACzB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;CACrB;;;CAGA;IACG,kBAAkB;IAClB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,UAAU;IACV,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,wBAAwB;IACxB,kBAAkB;IAGlB,mCAAmC;IACnC,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;;IAEE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAEhB,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAE3B,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;;EAEA;EACA;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,UAAU;EACZ;AACF;EACE;IACE,OAAO;IACP,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,8DAA8D;IAC9D,sEAAsE;EACxE;EACA;IACE;MACE,aAAa;IACf;EACF;EACA;IACE;MACE,kBAAkB;MAClB,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,UAAU;MACV,YAAY;IACd;EACF;EACA;IACE;;MAEE,eAAe;IACjB;IACA;MACE,WAAW;IACb;IACA;MACE,UAAU;MACV,WAAW;IACb;IACA;MACE,WAAW;MACX,WAAW;IACb;AACJ;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;IACI,UAAU;IACV,YAAY;IACZ,SAAS;EACX;EACA;IACE;MACE,UAAU;MACV,YAAY;IACd;EACF;EACA;IACE;;MAEE,eAAe;IACjB;IACA;MACE,WAAW;IACb;IACA;MACE,UAAU;MACV,WAAW;IACb;IACA;MACE,WAAW;MACX,WAAW;IACb;IACA;MACE,YAAY;MACZ,UAAU;IACZ;EACF;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;EACb;;;EAGA;IACE,kBAAkB;EACpB;AACF;IAGI,mCAAmC;IACnC,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;AACzC;AACA;IACI,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI;QACI,iCAAiC;IACrC;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,WAAW;QACX,gCAAgC;IACpC;AACJ;;AAEA,kCAAkC,eAAe,CAAC;;AAElD;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;AACd","sourcesContent":["\n\n.widget-listingsearch {\n    max-width: 750px;\n    margin: auto;\n  }\n\n.widget-listingsearch.style4 {\n    max-width: 100%;\n  }\n  .widget-listingsearch.style4 .search_jobs {\n    padding: 5px;\n    border-radius: 3px;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n    background: #fff;\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .search_jobs {\n      padding: 10px;\n    }\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .search-submit {\n      padding-left: 70px;\n      padding-right: 70px;\n    }\n  }\n  .widget-listingsearch.style4 .search-submit i {\n    display: none;\n  }\n\n  \n  .wpb_wrapper.head.blu:before {\n    background-image: radial-gradient(farthest-corner at 0% 100%,  #004C6C 0%, #53b8e2  100%);\n    background-image: -webkit-radial-gradient(farthest-corner at 0% 100%,  #004C6C 0%, #53b8e2  100%);  \n  }\n  .wpb_wrapper.head:before {\n    background-image: url(\"../../../public/bg.jpg\");\n    background-size: cover;\n    background-position: bottom;\n    display: block;\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 0;\n    opacity: 0.7;\n    filter: alpha(opacity = 70);\n    width: 100%;\n    height: 100%;\n  background-repeat: repeat-x;\n}\n\n.wpb_wrapper_blue.head:before {\n  background-image: none;\n  opacity: 1;\n  background-color: #1f80a8;\n}\n\n.wpb_wrapper_red.head:before {\n  background-image: none;\n  opacity: 1;\n  background-color: #bf1155;\n}\n\n.wpb_wrapper_green.head:before {\n  background-image: none;\n  opacity: 1;\n  background-color: #7a8e29;\n}\n\n.wpb_wrapper_aqua.head:before {\n  background-image: none;\n  opacity: 1;\n  background-color: #05948d;\n}\n\n.wpb_wrapper_orange.head:before {\n  background-image: none;\n  opacity: 1;\n  background-color: #d0810e;\n}\n\n.wpb_wrapper { color: #fff; position: relative; }\n.wpb_wrapper .description { font-size: 1.8em;\n}\n.wpb_wrapper h2 { color: #fff;\n    font-size: 45px;\n    font-weight: 700;\n    margin: 0;\n    text-align: center;\n }\n\n\n .job_search_form .has-suggestion {\n    position: relative;\n    width: 360px;\n    max-width: 100%;\n  }\n  .job_search_form .has-suggestion.active .navbar-collapse {\n    opacity: 1;\n    filter: alpha(opacity=100);\n    visibility: visible;\n  }\n  .job_search_form .has-suggestion .navbar-collapse {\n    opacity: 0;\n    filter: alpha(opacity=0);\n    visibility: hidden;\n    -webkit-transition: all 0.2s ease-in-out 0s;\n    -o-transition: all 0.2s ease-in-out 0s;\n    transition: all 0.2s ease-in-out 0s;\n    min-width: 360px;\n    z-index: 99;\n    padding: 0;\n    position: absolute;\n    top: 100%;\n    margin-top: 0;\n    left: -5px;\n  }\n  .rtl .job_search_form .has-suggestion .navbar-collapse {\n    right: -5px;\n    left: auto;\n  }\n  .job_search_form .filters_end {\n    display: none;\n  }\n  .job_search_form .search_categories,\n  .job_search_form .search_location {\n    width: 220px;\n    max-width: 100%;\n  }\n  .job_search_form .search-submit {\n    font-size: 17px;\n    font-weight: 300;\n    padding: 9px 30px;\n  }\n  .job_search_form .search-submit i {\n    line-height: 1;\n    vertical-align: sub;\n    margin-left: 10px;\n  }\n  .rtl .job_search_form .search-submit i {\n    margin-right: 10px;\n    margin-left: inherit;\n  }\n  .job_search_form .chosen-container-single,\n  .job_search_form input {\n    width: 100%;\n    height: 50px;\n    padding: 10px 20px;\n    border: none;\n    background: #fff;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n    border-radius: 3px;\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    -ms-border-radius: 3px;\n    -o-border-radius: 3px;\n  }\n  .job_search_form .chosen-container-single.search_location,\n  .job_search_form input.search_location {\n    padding: 10px 30px 10px 20px;\n  }\n  .job_search_form input {\n    color: #67676f;\n  }\n  .job_search_form input::-webkit-input-placeholder {\n    /* Chrome/Opera/Safari */\n    color: #67676f;\n  }\n  .job_search_form input::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #67676f;\n  }\n  .job_search_form input:-ms-input-placeholder {\n    /* IE 10+ */\n    color: #67676f;\n  }\n  .job_search_form input:-moz-placeholder {\n    /* Firefox 18- */\n    color: #67676f;\n  }\n  .job_search_form #search_keywords {\n    padding: 10px 20px;\n  }\n  .job_search_form .chosen-container {\n    font-size: 13px;\n  }\n  .job_search_form .chosen-single {\n    padding: 2px;\n    border: none !important;\n    background: #fff !important;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n  }\n  .job_search_form .chosen-single > div {\n    top: 2px !important;\n  }\n  .job_search_form .search_jobs > .inner-left {\n    width: 100%;\n  }\n  .job_search_form .table-wrapper > div {\n    position: relative;\n  }\n  .job_search_form .table-wrapper > div:last-child:before {\n    display: none;\n  }\n\n  @media (min-width: 1200px) {\n  .job_search_form .table-wrapper > div:before {\n    content: '';\n    width: 1px;\n    height: 30px;\n    background: #d7d7d7;\n    position: absolute;\n    top: 10px;\n    right: 0;\n    z-index: 9;\n  }\n}\n  .rtl .job_search_form .table-wrapper > div:before {\n    left: 0;\n    right: auto;\n  }\n  .job_search_form .search_location {\n    position: relative;\n  }\n  .job_search_form .search_location .clear-location {\n    background: transparent;\n    cursor: pointer;\n    height: 50px;\n    line-height: 50px;\n    position: absolute;\n    right: 25px;\n    text-align: center;\n    top: 2px;\n    width: 20px;\n  }\n  .rtl .job_search_form .search_location .clear-location {\n    left: 25px;\n    right: auto;\n  }\n  .job_search_form .search_location .clear-location i {\n    display: block;\n    font-size: 18px;\n    line-height: 43px;\n    color: #fb3640;\n  }\n  .job_search_form .search_location .find-me {\n    background: transparent;\n    cursor: pointer;\n    height: 50px;\n    line-height: 50px;\n    position: absolute;\n    right: 10px;\n    text-align: center;\n    top: 2px;\n    width: 20px;\n  }\n  .rtl .job_search_form .search_location .find-me {\n    left: 10px;\n    right: auto;\n  }\n  .job_search_form .search_location .find-me i {\n    display: block;\n  }\n  .job_search_form .search_location .find-me.loading {\n    background: transparent;\n  }\n  .job_search_form .search_location .find-me.loading > * {\n    animation: rotate 700ms linear 0s normal none infinite running;\n    -webkit-animation: rotate 700ms linear 0s normal none infinite running;\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .search_jobs {\n      padding: 10px;\n    }\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .search-submit {\n      padding-left: 70px;\n      padding-right: 70px;\n    }\n  }\n\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {\n      top: -10px;\n      height: 70px;\n    }\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .job_search_form .search_location,\n    .widget-listingsearch.style4 .job_search_form .search_categories {\n      padding: 0 10px;\n    }\n    .widget-listingsearch.style4 .job_search_form .search_location .find-me {\n      right: 20px;\n    }\n    .rtl .widget-listingsearch.style4 .job_search_form .search_location .find-me {\n      left: 20px;\n      right: auto;\n    }\n    .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {\n      left: -10px;\n      width: 100%;\n    }\n}\n.widget-listingsearch.style4 .chosen-container-single .chosen-single span {\n  color: #67676f;\n}\n.widget-listingsearch.style4 .job_search_form .search_location .clear-location {\n  right: 35px;\n}\n.rtl .widget-listingsearch.style4 .job_search_form .search_location .clear-location {\n  left: 35px;\n  right: auto;\n}\n.widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {\n    width: 1px;\n    height: 60px;\n    top: -5px;\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .job_search_form .table-wrapper > div::before {\n      top: -10px;\n      height: 70px;\n    }\n  }\n  @media (min-width: 1200px) {\n    .widget-listingsearch.style4 .job_search_form .search_location,\n    .widget-listingsearch.style4 .job_search_form .search_categories {\n      padding: 0 10px;\n    }\n    .widget-listingsearch.style4 .job_search_form .search_location .find-me {\n      right: 20px;\n    }\n    .rtl .widget-listingsearch.style4 .job_search_form .search_location .find-me {\n      left: 20px;\n      right: auto;\n    }\n    .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {\n      left: -10px;\n      width: 100%;\n    }\n    .rtl .widget-listingsearch.style4 .job_search_form .has-suggestion .navbar-collapse {\n      right: -10px;\n      left: auto;\n    }\n  }\n  .widget-listingsearch.style4 .chosen-container-single .chosen-single span {\n    color: #67676f;\n  }\n  .widget-listingsearch.style4 .job_search_form .search_location .clear-location {\n    right: 35px;\n  }\n  .rtl .widget-listingsearch.style4 .job_search_form .search_location .clear-location {\n    left: 35px;\n    right: auto;\n  }\n\n\n  .categories-inner {\n    text-align: center;\n  }\n.listing-category-item {\n    -webkit-transition: all 0.2s ease-in-out 0s;\n    -o-transition: all 0.2s ease-in-out 0s;\n    transition: all 0.2s ease-in-out 0s;\n    display: inline-block;\n    text-align: center;\n    padding: 0 5px;\n    margin-bottom: 10px;\n}\n\n.listing-category-item  .inner {\n    padding: 8px 5px;\n    background: rgba(255, 255, 255, 0.28);\n}\n.listing-category-item .category-icon {\n    color: #fff;\n    font-size: 35px;\n    display: inline-block;\n    line-height: 1;\n}\n\n.listing-category-item .inner {\n    max-width: 30vw;\n    min-width: 23vw;\n}\n\n.listing-category-item .category-info-title {\n    font-size: 16px;\n    color: #fff;\n}\n.widget-listing-categories.style5 .category-number {\n    display: none;\n}\n\n.search_jobs select  {\n    height: 100%;\n    border-bottom-width: 0 !important;\n}\n.search_jobs .visible-table  {\n    display: flex;\n    justify-content: space-between;\n}\n.search_jobs .grow1  {\n    flex-grow: 1;\n}\n\n.search_jobs .search-submit {\n    background: #004C6C;\n    border-color: #004C6C;\n    color: #FFF; \n    display: flex;\n    width: 100%;\n    height: 100%;\n}\n\n\n@media (max-width: 1200px) {\n    .search_jobs .visible-table  {\n        flex-direction: column !important;\n    }\n    .search_jobs .visible-table  > * {\n        width: 100%;\n    }\n    .search-filter-wrapper {\n        margin-bottom: 5px;\n        padding: 0;\n        width: 100%;\n        border-bottom: 1px solid #ebebeb;\n    }\n}\n\n.react-multi-carousel-list  img { max-width: 100%;}\n\nselect {\n    padding: 10px 20px;\n}\n\n.card-home {\n    padding: 20px;\n    margin-top: 10rem;\n}\n\n.dashboard-container .card {\n  margin-top: 0em;\n}\n\n.apus-footer {\n  position: relative;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 10rem 0 0;\n}\n\n.apus-footer .purple {\n    background: #252c41;\n    color: #858b9f;\n  }\n  .apus-footer .purple .wpb_heading,\n  .apus-footer .purple .widget-title, .apus-footer .purple .widgettitle {\n    color: #fff;\n  }\n  .apus-footer .purple a:not([classs]) {\n    color: #858b9f;\n  }\n  .apus-footer .purple a:not([classs]):hover, .apus-footer .purple a:not([classs]):active, .apus-footer .purple a:not([classs]):focus {\n    color: #fff;\n  }\n  .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a {\n    border-color: #3c4358;\n  }\n  .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a:hover, .apus-footer .purple .wpb_image_grid .wpb_image_grid_ul li a:focus {\n    border-color: #fff;\n  }\n  .menu {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n  .menu li {\n    margin-bottom: 3px;\n  }\n  .menu li:last-child {\n    margin: 0;\n  }\n  .widget_nav_menu .menu li a {\n    padding: 5px 0;\n    display: inline-block;\n    text-decoration: none;\n}    \n\n.apus-footer .widgettitle {\n    text-align: left;\n    color: #28b8dc;\n    font-size: 18px;\n    font-weight: 400;\n    margin: 0 0 10px;\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
